var map = {
	"./1.jpg": 83693,
	"./10.jpg": 95425,
	"./17.jpg": 27410,
	"./3.jpg": 29471,
	"./4.jpg": 61684,
	"./5.jpg": 76017,
	"./6.jpg": 48262,
	"./7.jpg": 7747,
	"./8.jpg": 23288,
	"./9.jpg": 31157
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56487;